(() => {
  const initialize = async catalog => {
    if (catalog.dataset.zReady) return;
    catalog.dataset.zReady = 'loading';
    const grid = catalog.querySelector('[data-z-catalog-grid]');
    const tools = catalog.querySelector('[data-z-filter-tools]');
    if (!grid || !tools) return;
    let next = catalog.dataset.zNext;
    const loadedIds = new Set([...grid.querySelectorAll('[data-z-product-id]')].map(item => item.dataset.zProductId));
    const seenPages = new Set();
    try {
      while (next) {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin || seenPages.has(url.href)) return;
        seenPages.add(url.href);
        const response = await fetch(url.href, {credentials: 'same-origin', headers: {'Accept': 'text/html'}});
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextCatalog = [...page.querySelectorAll('[data-z-catalog]')].find(element => element.dataset.zCatalog === catalog.dataset.zCatalog);
        if (!nextCatalog) return;
        nextCatalog.querySelectorAll('[data-z-catalog-item]').forEach(item => {
          if (!loadedIds.has(item.dataset.zProductId)) {
            loadedIds.add(item.dataset.zProductId);
            grid.append(item);
          }
        });
        next = nextCatalog.dataset.zNext;
      }
    } catch {
      return;
    }
    const items = [...grid.querySelectorAll('[data-z-catalog-item]')];
    const buttons = [...tools.querySelectorAll('[data-z-family], [data-z-category]')];
    const empty = catalog.querySelector('[data-z-empty]');
    const count = catalog.querySelector('[data-z-count]');
    const resetButtons = [...catalog.querySelectorAll('[data-z-reset]')];
    const pagination = catalog.querySelector('[data-z-catalog-pagination]');
    const state = {family: 'all', category: 'all'};
    const matches = item => (state.family === 'all' || item.dataset.zFamilyTags.split(' ').includes(state.family)) && (state.category === 'all' || item.dataset.zCategoryTag === state.category);
    const update = () => {
      let visible = 0;
      items.forEach(item => {
        const show = matches(item);
        item.hidden = !show;
        if (show) visible++;
      });
      buttons.forEach(button => {
        const group = button.hasAttribute('data-z-family') ? 'family' : 'category';
        const value = group === 'family' ? button.dataset.zFamily : button.dataset.zCategory;
        button.setAttribute('aria-pressed', String(state[group] === value));
      });
      count.textContent = visible === 1 ? catalog.dataset.countOne : catalog.dataset.countMany.replace('999', new Intl.NumberFormat(document.documentElement.lang || 'en').format(visible));
      empty.hidden = visible > 0;
      tools.querySelector('[data-z-reset]').hidden = state.family === 'all' && state.category === 'all';
    };
    buttons.forEach(button => {
      const group = button.hasAttribute('data-z-family') ? 'family' : 'category';
      const value = group === 'family' ? button.dataset.zFamily : button.dataset.zCategory;
      if (value !== 'all' && !items.some(item => group === 'family' ? item.dataset.zFamilyTags.split(' ').includes(value) : item.dataset.zCategoryTag === value)) button.hidden = true;
      button.addEventListener('click', () => {
        state[group] = value;
        update();
      });
    });
    resetButtons.forEach(button => button.addEventListener('click', () => {
      state.family = 'all';
      state.category = 'all';
      update();
    }));
    if (pagination) pagination.hidden = true;
    tools.hidden = false;
    catalog.dataset.zReady = 'true';
    update();
  };
  const boot = root => root.querySelectorAll('[data-z-catalog]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once: true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
